import { useState, createContext, useEffect, useRef } from 'react'
import { useFetch } from './useFetch';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
// import plans from './db.json'
export const appContext = createContext();


function checkStockMarketDate(base64date) {
    if (!base64date) return false;
    try {
      const date = new Date(atob(base64date)).valueOf();
      const dateObj = new Date();
      const delta = new Date(dateObj.setDate(dateObj.getDate() - 1)).valueOf();
      return delta < date;
    }
    catch (e) {
      return false;
    }
  
  }
  

export default function AppContext({ children }) {

    const [searchParams] = useSearchParams();

    const [urlAgent, setUrlAgent] = useState({
        mainAgent: searchParams.get('mainAgent') || '',
        agent: searchParams.get('agent') || '',
        enabledBirthDay: (searchParams.get('bd_enabled') === '1') ? true : false,
        owner: searchParams.get('owner') || '',
        lead: searchParams.get('lead') || '',
        donor: searchParams.get('donor') || '',
        stockMarket: checkStockMarketDate(searchParams.get('sm')),
    })

    const [user, setUser] = useState({ firstName: '', lastName: '', email: '', mobile: '', personId: '' });

    const toastsRef = useRef()

    const { fetchOptions, data, isPending, error, setFetch } = useFetch();

    const navigate = useNavigate();

    // try to load lead data
    useEffect(() => {
        // Resuming a lead takes priority over the existing donor entry point
        if (!urlAgent.lead && !urlAgent.donor)
            return
        if (urlAgent.lead)
            setFetch({ route: '/lead?id=' + urlAgent.lead })
        else
            // Existing donor (SF Person Account) - prefill only, the lead is created on submit
            setFetch({ route: '/donor?id=' + urlAgent.donor })
        if (toastsRef.current)
            toast.update(toastsRef.current, { isLoading: true, render: 'טעינת נתונים, אנא המתן', rtl: true })
        else
            toastsRef.current = toast.loading("טעינת נתונים, אנא המתן", { position: toast.POSITION.TOP_CENTER, rtl: true });
    }, [urlAgent.lead, urlAgent.donor, setFetch])

    // Save user lead Id 
    useEffect(() => {
        if (data?.lead) {
            setUser(data.lead);
            setUrlAgent(prev => ({
                ...prev,
                agent: (data.lead?.agent) ? data.lead.agent : prev.agent,
                mainAgent: (data.lead?.mainAgent)? data.lead.mainAgent: prev.mainAgent
            }))
            toast.done(toastsRef.current);
        }
        if (data?.unitRequest) {
            setUser(data.unitRequest);
            if (data.unitRequest.agent)
                setUrlAgent(prev => ({ ...prev, agent: data.unitRequest.agent }))
         }        
        if (data?.leadId) { setUser(prev => { return { ...prev, id: data.leadId } }); toast.done(toastsRef.current) }
    }, [data])

    // Handle Fetch Errors
    useEffect(() => {
        if (error && !isPending) {            
            if ('msg' in error) {
                toast.error(error.msg, { position: toast.POSITION.TOP_CENTER });
                return
            }
            if (fetchOptions.route?.startsWith('/lead?id=') || fetchOptions.route?.startsWith('/donor?id=')) {
                let message = 'טעינת נתונים נכשלה';
                if (error?.message.includes('completed unit request cannot be modified'))
                    message = 'בקשה הצטרפות הושלמה ולא ניתנת לעריכה בסימולטור ';
                if (toastsRef.current)
                    toast.update(toastsRef.current, { isLoading: false, type: toast.TYPE.ERROR, render: message, autoClose: 5000 })
                else
                    toast.error(message, { position: toast.POSITION.TOP_CENTER });
                setUrlAgent(prev => ({ ...prev, lead: null, donor: null }))
                return
            }
            if (['/lead', '/unit-request', '/bank-info', '/credit-card-info'].includes(fetchOptions.route)) {
                toast.error("שמירת נתונים נכשלה", { position: toast.POSITION.TOP_CENTER });
                return
            }
            toast.error("שגיאה בחיבור לשרת", { position: toast.POSITION.TOP_CENTER });
        }

    }, [fetchOptions.route, error, isPending])

    // Fetch plans from Backend
    const { data: plans } = useFetch('/plans');
    // Preload family plans app-wide so the family-plan popup never waits on the fetch
    const { data: familyPlans } = useFetch('/family-plans');

    const value = { user, setUser, data, error, isPending, setFetch, navigate, plans, familyPlans, fetchOptions, urlAgent };

    return (
        <appContext.Provider value={value}>
            {children}
        </appContext.Provider >
    )
}
